module.exports = __webpack_public_path__ + "img/arrow_down_default.eec39b01.svg";